import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'

export const TopNavContainer = forwardRef((props, ref) => {
  const { as = 'div', children, className, ...rest } = props
  const Comp = as

  const classes = ['dev_dash__top-nav--container', className].join(' ').trim()

  return (
    <Comp className={classes} ref={ref} {...rest}>
      {children}
    </Comp>
  )
})

TopNavContainer.displayName = 'TopNavContainer'

TopNavContainer.propTypes = {
  as: PropTypes.any,
  children: PropTypes.any.isRequired,
  className: PropTypes.string,
}
